import { useMapContext } from "@evergis/react";
import { AnimationEndEvent } from "@evergis/sgis/es/Map";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { resetSelectedFeatures } from "../../../ducks/selectFeatures/selectFeatures";
import { FeatureDcExtended } from "../../../ducks/selectFeatures/types";
import { useSetShowFeature } from "../../../ducks/showFeature/hooks";
import { setTableSelectedFeature } from "../../../ducks/table/table";
import { api } from "../../../evergis/api";
import { useFeatureCard } from "../../FeatureCard/hooks/useFeatureCard";

export const useShowFeatureCard = (layerName: string) => {
  const [, { zoomToFeature }] = useFeatureCard();
  const setFeatureToShow = useSetShowFeature(layerName);
  const dispatch = useDispatch();
  const { map } = useMapContext();

  return useCallback(
    async (id: string, withoutZoom?: boolean) => {
      const currentFeature = (await api.layers.getById({ name: layerName, id })) as FeatureDcExtended;

      if (currentFeature) {
        dispatch(resetSelectedFeatures());

        if (currentFeature.geometry) {
          if (withoutZoom) {
            dispatch(setTableSelectedFeature(currentFeature));
            setFeatureToShow(currentFeature);
          } else {
            zoomToFeature(currentFeature);

            map.once(AnimationEndEvent.type, () => {
              dispatch(setTableSelectedFeature(currentFeature));
              setFeatureToShow(currentFeature);
            });
          }
        } else {
          dispatch(setTableSelectedFeature(currentFeature));
          setFeatureToShow(currentFeature);
        }
      }
    },
    [dispatch, layerName, map, setFeatureToShow, zoomToFeature],
  );
};
